import { Link } from "react-router-dom";
import {
  ArrowUpRight, BookOpen, Check, Eye, Flower2, Footprints, GraduationCap,
  Hand, HeartHandshake, Layers, Route, Sparkles, Wind,
} from "lucide-react";
import { Reveal } from "../components/Reveal";

const WA = "https://wa.me/33623502131?text=Bonjour%20Julie%2C%20je%20suis%20int%C3%A9ress%C3%A9e%20par%20la%20formation%20professionnelle%20Chi%20Nei%20Tsang%2C%20peux-tu%20m%27envoyer%20les%20infos%20%3F";
const CONTACT = "/contact?soin=formation";

const POUR_QUI = [
  { icon: HeartHandshake, label: "Thérapeutes" },
  { icon: Hand, label: "Praticiens en massage" },
  { icon: Flower2, label: "Professionnels du bien-être" },
  { icon: Sparkles, label: "Praticiens en énergétique" },
  { icon: Footprints, label: "Réflexologues" },
  { icon: GraduationCap, label: "Professionnels souhaitant enrichir leur pratique corporelle" },
];

const APPRENTISSAGES = [
  { icon: BookOpen, title: "Anatomie du ventre", text: "Comprendre les principales structures abdominales et leur organisation." },
  { icon: Layers, title: "Fascias", text: "Découvrir leur rôle et développer un toucher plus subtil et conscient." },
  { icon: Sparkles, title: "Organes et énergétique", text: "Explorer les correspondances traditionnelles utilisées dans l'approche du Chi Nei Tsang." },
  { icon: Route, title: "Méridiens", text: "Comprendre les principaux trajets et leur intérêt dans la pratique." },
  { icon: Wind, title: "Respiration et écoute corporelle", text: "Apprendre à travailler avec le souffle, les sensations et la présence." },
  { icon: Hand, title: "Gestuelle", text: "Acquérir des bases techniques et des protocoles structurés." },
  { icon: Eye, title: "Posture du praticien", text: "Développer présence, discernement, écoute et qualité d'accompagnement." },
];

const JOURS = [
  { jour: "Jour 1", titre: "Comprendre", text: "Fondamentaux du Chi Nei Tsang, philosophie, anatomie et découverte du ventre." },
  { jour: "Jour 2", titre: "Sentir", text: "Toucher, écoute, respiration et premiers protocoles." },
  { jour: "Jour 3", titre: "Approfondir", text: "Organes, fascias, méridiens et approfondissement de la pratique." },
  { jour: "Jour 4", titre: "Intégrer", text: "Protocoles complets, observation et adaptation à la personne." },
  { jour: "Jour 5", titre: "Transmettre", text: "Pratique globale, corrections, intégration et autonomie." },
];

const ACQUIS = [
  "Les fondamentaux du Chi Nei Tsang",
  "Des protocoles structurés",
  "Une compréhension des principales notions anatomiques",
  "Des repères sur les fascias",
  "Des notions sur les méridiens",
  "Les correspondances traditionnelles organes / émotions",
  "Une expérience pratique intensive",
  "Un support pédagogique",
  "Un certificat de formation",
];

const INFOS = [
  { label: "Durée", value: "5 jours", aRenseigner: false },
  { label: "Dates", value: "Du 26 au 30 octobre 2026", aRenseigner: false },
  { label: "Lieu", value: "Bayonne", aRenseigner: false },
  { label: "Tarif", value: "1 100 €", aRenseigner: false },
  { label: "Nombre de participants", value: "4 places ouvertes", aRenseigner: false },
];

const FAQ = [
  { q: "Faut-il déjà être thérapeute ?", a: "Cette formation s'adresse aux professionnels de l'accompagnement corporel et aux personnes souhaitant enrichir leur pratique par une approche spécifique du ventre. Elle demande avant tout une réelle envie d'apprendre, de pratiquer et de développer la qualité de son toucher." },
  { q: "Faut-il avoir une expérience en massage ?", a: "Chaque notion abordée est progressivement expérimentée, ressentie et intégrée à travers la pratique. L'essentiel est l'envie d'apprendre et de développer la qualité de son toucher." },
  { q: "La formation est-elle principalement pratique ?", a: "Oui. Le Chi Nei Tsang ne s'apprend pas uniquement dans les livres : la pratique occupe une place centrale dans la formation, avec observation, correction et intégration progressive." },
  { q: "Le matériel est-il fourni ?", a: "Aucun matériel n'est à prévoir. Un livret de formation vous est remis pour accompagner votre pratique pendant et après les 5 jours." },
  { q: "Reçoit-on un certificat ?", a: "Oui — un certificat de formation est remis à la fin des 5 jours, accompagné d'un support pédagogique." },
  { q: "Combien de personnes participent à la formation ?", a: "La formation se déroule en petit groupe — 4 places ouvertes pour la session du 26 au 30 octobre 2026 — pour garantir un apprentissage pratique, humain et de qualité." },
  { q: "Peut-on intégrer le Chi Nei Tsang à sa pratique professionnelle ?", a: "Oui. Vous repartez avec les fondamentaux, des protocoles structurés et une expérience pratique intensive, pour intégrer progressivement ce massage abdominal à votre pratique professionnelle." },
];

const CtaInfos = ({ testid }) => (
  <Link to={CONTACT} data-testid={testid} className="inline-flex items-center gap-2 rounded-full bg-olive px-8 py-4 text-sm font-medium text-beige-100 transition-all duration-300 hover:bg-olive-dark hover:-translate-y-0.5">
    Je souhaite recevoir les informations <ArrowUpRight className="w-4 h-4" strokeWidth={1.5} />
  </Link>
);

export default function LandingCNT() {
  return (
    <div data-testid="landing-cnt" className="bg-beige-100 text-ink min-h-screen">
      {/* MINI BARRE */}
      <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-md bg-beige-100/85 border-b border-olive-border/60">
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" data-testid="landing-cnt-brand" className="flex items-center gap-2">
            <img src="/images/logo-icon.png" alt="" className="h-7 w-7 object-contain" />
            <span className="font-serif text-lg">Julie Zittel</span>
          </Link>
          <div className="flex items-center gap-4">
            <Link to="/formations" data-testid="landing-cnt-back" className="hidden sm:inline-block text-xs uppercase tracking-[0.2em] text-olive hover:text-olive-dark transition-colors">Toutes les formations</Link>
            <a href={WA} target="_blank" rel="noopener noreferrer" data-testid="landing-cnt-whatsapp-top" className="inline-flex items-center rounded-full bg-[#25D366] px-4 py-2 text-xs sm:text-sm font-medium text-white transition-transform duration-300 hover:scale-105">
              WhatsApp
            </a>
          </div>
        </div>
      </header>

      {/* SECTION 1 — HERO */}
      <section className="relative min-h-screen flex items-end overflow-hidden">
        <img src="/images/chi-nei-tsang.jpg" alt="Mains du praticien posées sur le ventre — formation Chi Nei Tsang, massage abdominal" className="absolute inset-0 w-full h-full object-cover" data-testid="cnt-hero-image" />
        <div className="absolute inset-0 bg-gradient-to-t from-olive-dark/90 via-olive-dark/45 to-olive-dark/15" />
        <div className="relative w-full max-w-6xl mx-auto px-6 pb-20 pt-40">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.3em] text-gold mb-6">Formation Chi Nei Tsang · France</p>
            <h1 className="font-serif text-4xl sm:text-6xl lg:text-7xl font-light leading-[1.08] text-beige-100 max-w-4xl">
              Formation professionnelle<br />Chi Nei Tsang
            </h1>
            <p className="mt-6 font-serif text-xl sm:text-2xl font-light italic text-beige-200 max-w-2xl">
              Apprendre à accompagner le ventre avec précision, présence et profondeur.
            </p>
            <p className="mt-5 max-w-xl text-beige-200/90 leading-relaxed">
              Une formation en présentiel pour découvrir et intégrer les fondamentaux du Chi Nei Tsang, développer la qualité de son toucher et apprendre à accompagner le ventre avec davantage d'écoute, de discernement et de présence.
            </p>
            <div className="mt-7 flex flex-wrap gap-3 text-sm text-olive-dark">
              <span className="inline-flex items-center rounded-full bg-beige-100/90 px-4 py-2 font-medium" data-testid="cnt-badge-duree">5 jours</span>
              <span className="inline-flex items-center rounded-full bg-beige-100/90 px-4 py-2" data-testid="cnt-badge-presentiel">Formation en présentiel</span>
              <span className="inline-flex items-center rounded-full bg-beige-100/90 px-4 py-2" data-testid="cnt-badge-groupe">Petit groupe</span>
              <span className="inline-flex items-center rounded-full bg-gold px-4 py-2 font-medium" data-testid="cnt-badge-places">Plus que 4 places</span>
            </div>
            <div className="mt-9">
              <CtaInfos testid="cnt-cta-hero" />
            </div>
          </Reveal>
        </div>
      </section>

      {/* SECTION 2 — ACCROCHE ÉMOTIONNELLE */}
      <section className="py-24 lg:py-28 px-6 max-w-6xl mx-auto" data-testid="cnt-accroche">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <Reveal>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight leading-tight">
              Et si le ventre devenait une véritable porte d'entrée vers le corps ?
            </h2>
            <p className="mt-7 text-sage leading-relaxed">
              Le ventre ne se résume pas à une zone anatomique. Il est au cœur de nombreuses fonctions du corps et occupe une place particulière dans les approches énergétiques et corporelles.
            </p>
            <p className="mt-4 text-sage leading-relaxed">
              À travers cette formation, je transmets une approche du Chi Nei Tsang qui associe compréhension du corps, qualité du toucher, écoute et présence.
            </p>
            <p className="mt-4 text-sage leading-relaxed">
              L'objectif n'est pas simplement d'apprendre une succession de gestes. C'est apprendre à sentir, à observer, à discerner et à accompagner.
            </p>
            <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-3">
              {["Comprendre", "Sentir", "Pratiquer", "Intégrer"].map((m) => (
                <span key={m} className="rounded-2xl border border-olive-border bg-beige-50 px-4 py-4 text-center text-xs uppercase tracking-[0.2em] text-olive-dark font-medium" data-testid={`cnt-mot-${m.toLowerCase()}`}>{m}</span>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="overflow-hidden rounded-3xl border border-olive-border shadow-[0_25px_50px_-25px_rgba(49,63,21,0.35)]">
              <img src="/images/ventre.jpg" alt="Toucher du ventre en Chi Nei Tsang — écoute et présence" loading="lazy" className="w-full h-[420px] lg:h-[540px] object-cover" data-testid="cnt-image-ventre" />
            </div>
          </Reveal>
        </div>
      </section>

      {/* SECTION 3 — POUR QUI ? */}
      <section className="pb-24 lg:pb-28 px-6 max-w-6xl mx-auto" data-testid="cnt-pour-qui">
        <Reveal className="mb-12 max-w-3xl">
          <p className="text-xs uppercase tracking-[0.3em] text-olive mb-4">Pour qui ?</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">À qui s'adresse cette formation ?</h2>
          <p className="mt-6 text-sage leading-relaxed">
            Cette formation s'adresse aux professionnels de l'accompagnement corporel et aux personnes souhaitant enrichir leur pratique par une approche spécifique du ventre.
          </p>
        </Reveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {POUR_QUI.map((c, i) => (
            <Reveal key={c.label} delay={(i % 3) * 0.08}>
              <div className="h-full flex items-center gap-4 rounded-2xl border border-olive-border bg-beige-50 p-6 transition-colors duration-300 hover:bg-olive-soft/40" data-testid={`cnt-carte-${i}`}>
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-olive-soft border border-olive-border">
                  <c.icon className="w-5 h-5 text-olive" strokeWidth={1.5} />
                </span>
                <h3 className="font-serif text-lg text-ink leading-snug">{c.label}</h3>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.1}>
          <p className="mt-10 max-w-2xl font-serif text-xl sm:text-2xl font-light italic text-olive-dark leading-relaxed">
            Cette formation demande avant tout une réelle envie d'apprendre, de pratiquer et de développer la qualité de son toucher.
          </p>
        </Reveal>
      </section>

      {/* SECTION 4 — CE QUE VOUS ALLEZ APPRENDRE */}
      <section className="pb-24 lg:pb-28 px-6 max-w-6xl mx-auto" data-testid="cnt-apprentissages">
        <Reveal className="mb-14">
          <p className="text-xs uppercase tracking-[0.3em] text-olive mb-4">Le contenu</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">Ce que vous allez apprendre</h2>
        </Reveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-12">
          {APPRENTISSAGES.map((a, i) => (
            <Reveal key={a.title} delay={(i % 3) * 0.08}>
              <div className="border-t-2 border-olive pt-6" data-testid={`cnt-appr-${i}`}>
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-olive-soft border border-olive-border">
                  <a.icon className="w-5 h-5 text-olive" strokeWidth={1.5} />
                </span>
                <h3 className="mt-5 font-serif text-2xl text-ink">{a.title}</h3>
                <p className="mt-3 text-sm sm:text-base text-sage leading-relaxed">{a.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* SECTION 5 — LA PRATIQUE */}
      <section className="bg-olive-dark text-beige-100" data-testid="cnt-pratique">
        <div className="max-w-6xl mx-auto px-6 py-24 lg:py-28 grid lg:grid-cols-2 gap-14 items-center">
          <Reveal>
            <div className="overflow-hidden rounded-3xl border border-beige-100/15">
              <img src="/images/amma.jpg" alt="Julie en pratique — apprendre le Chi Nei Tsang par le toucher" loading="lazy" className="w-full h-[420px] lg:h-[520px] object-cover" data-testid="cnt-image-pratique" />
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="text-xs uppercase tracking-[0.3em] text-gold mb-4">La pratique</p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light leading-tight">Une formation où l'on apprend en pratiquant</h2>
            <p className="mt-7 text-beige-300/90 leading-relaxed">
              Le Chi Nei Tsang ne s'apprend pas uniquement dans les livres. La pratique occupe une place centrale dans la formation.
            </p>
            <p className="mt-4 text-beige-300/90 leading-relaxed">
              Chaque notion abordée est progressivement expérimentée, ressentie et intégrée à travers la pratique. L'objectif est de permettre à chaque participant de développer progressivement sa propre qualité de toucher, tout en comprenant ce qu'il fait et pourquoi il le fait.
            </p>
            <div className="mt-8 grid grid-cols-2 gap-3">
              {["Pratique", "Observation", "Correction", "Intégration"].map((m) => (
                <span key={m} className="rounded-2xl border border-beige-100/20 bg-beige-100/5 px-4 py-4 text-center text-xs uppercase tracking-[0.2em] text-gold font-medium" data-testid={`cnt-prat-${m.toLowerCase()}`}>{m}</span>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      {/* SECTION 6 — PROGRAMME DES 5 JOURS */}
      <section className="py-24 lg:py-28 px-6 max-w-4xl mx-auto" data-testid="cnt-programme">
        <Reveal className="mb-14 text-center">
          <p className="text-xs uppercase tracking-[0.3em] text-olive mb-4">Le programme</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">5 jours pour apprendre, pratiquer et intégrer</h2>
        </Reveal>
        <div className="space-y-5">
          {JOURS.map((j, i) => (
            <Reveal key={j.jour} delay={i * 0.07}>
              <div className="grid sm:grid-cols-[10rem_1fr] gap-3 sm:gap-8 items-start rounded-2xl border border-olive-border bg-beige-50 p-7 transition-colors duration-300 hover:bg-olive-soft/40" data-testid={`cnt-jour-${i + 1}`}>
                <div>
                  <p className="text-xs uppercase tracking-[0.25em] text-olive">{j.jour}</p>
                  <h3 className="mt-1 font-serif text-2xl text-ink">{j.titre}</h3>
                </div>
                <p className="text-sage leading-relaxed">{j.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* SECTION 7 — MA TRANSMISSION */}
      <section className="pb-24 lg:pb-28 px-6 max-w-6xl mx-auto" data-testid="cnt-transmission">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <Reveal>
            <div className="overflow-hidden rounded-3xl border border-olive-border shadow-[0_25px_50px_-25px_rgba(49,63,21,0.35)] max-w-md">
              <img src="/images/portrait-cnt.jpg" alt="Julie Zittel, thérapeute et formatrice en Chi Nei Tsang" loading="lazy" className="w-full h-auto object-cover" data-testid="cnt-image-julie" />
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="text-xs uppercase tracking-[0.3em] text-olive mb-4">Ma transmission</p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">Ma façon de transmettre</h2>
            <p className="mt-7 text-sage leading-relaxed">
              Je suis Julie Zittel, thérapeute et formatrice depuis plus de 25 ans. La transmission occupe une place essentielle dans mon parcours.
            </p>
            <p className="mt-4 text-sage leading-relaxed">
              Je ne souhaite pas simplement transmettre des gestes ou des protocoles. Je souhaite transmettre une compréhension. Comprendre ce que l'on fait. Sentir ce que l'on touche. Observer ce qui se passe. Savoir s'adapter.
            </p>
            <p className="mt-4 text-sage leading-relaxed">
              Parce qu'un protocole appris par cœur ne remplacera jamais la capacité du praticien à écouter véritablement le corps.
            </p>
            <blockquote className="mt-8 border-l-2 border-gold pl-6 font-serif text-xl sm:text-2xl font-light italic text-olive-dark leading-relaxed" data-testid="cnt-citation">
              « Éduquer en discernant l'immense énergie interne de guérison et permettre à chacun de devenir progressivement autonome dans sa pratique. »
            </blockquote>
          </Reveal>
        </div>
      </section>

      {/* SECTION 8 — CE QUE VOUS EMPORTEZ */}
      <section className="pb-24 lg:pb-28 px-6 max-w-6xl mx-auto" data-testid="cnt-acquis">
        <div className="rounded-3xl border border-olive-border bg-beige-50 p-8 sm:p-12">
          <Reveal className="mb-10">
            <p className="text-xs uppercase tracking-[0.3em] text-olive mb-4">Les acquis</p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">À la fin de la formation</h2>
          </Reveal>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-4">
            {ACQUIS.map((x) => (
              <Reveal key={x}>
                <p className="flex items-start gap-3 text-sm sm:text-base text-ink leading-relaxed">
                  <Check className="w-4 h-4 mt-1 shrink-0 text-olive" strokeWidth={2} /> {x}
                </p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* SECTION 9 — TÉMOIGNAGE */}
      <section className="py-24 lg:py-28 px-6 bg-olive-soft/50 border-y border-olive-border" data-testid="cnt-temoignage">
        <Reveal>
          <div className="max-w-3xl mx-auto text-center">
            <p className="text-xs uppercase tracking-[0.3em] text-olive mb-8">Ils l'ont vécue</p>
            <blockquote className="font-serif text-2xl sm:text-3xl font-light italic text-ink leading-relaxed">
              « Une semaine de formation incroyable, je suis tellement heureuse d'avoir pu apprendre le Chi Nei Tsang à ses côtés. Une personne particulière à mes yeux, qui cette fois, m'a transmis toutes ses connaissances et son énergie. Je recommande les yeux fermés absolument tout ce qu'elle propose. »
            </blockquote>
            <p className="mt-8 text-sm uppercase tracking-[0.25em] text-sage" data-testid="cnt-temoignage-auteur">Manon — formation Chi Nei Tsang</p>
          </div>
        </Reveal>
      </section>

      {/* SECTION 10 — INFORMATIONS PRATIQUES */}
      <section className="py-24 lg:py-28 px-6 max-w-6xl mx-auto" data-testid="cnt-infos">
        <Reveal className="mb-12 text-center">
          <p className="text-xs uppercase tracking-[0.3em] text-olive mb-4">En pratique</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">Informations pratiques</h2>
        </Reveal>
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-5 max-w-5xl mx-auto">
          {INFOS.map((f) => (
            <Reveal key={f.label}>
              <div className={`h-full rounded-2xl border p-6 text-center ${f.aRenseigner ? "border-dashed border-gold bg-gold/10" : "border-olive-border bg-beige-50"}`} data-testid={`cnt-info-${f.label.toLowerCase().replace(/\s+/g, "-")}`}>
                <p className="text-xs uppercase tracking-[0.2em] text-olive">{f.label}</p>
                <p className={`mt-3 font-serif text-lg leading-snug ${f.aRenseigner ? "text-terracotta" : "text-ink"}`}>{f.value}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.1}>
          <div className="mt-12 text-center">
            <CtaInfos testid="cnt-cta-infos" />
          </div>
        </Reveal>
      </section>

      {/* SECTION 11 — FAQ */}
      <section className="pb-24 lg:pb-28 px-6 max-w-4xl mx-auto" data-testid="cnt-faq">
        <Reveal className="mb-12 text-center">
          <p className="text-xs uppercase tracking-[0.3em] text-olive mb-4">FAQ</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">Vos questions</h2>
        </Reveal>
        <div className="space-y-5">
          {FAQ.map((f, i) => (
            <Reveal key={f.q} delay={i * 0.06}>
              <div className="rounded-2xl border border-olive-border bg-beige-50 p-7" data-testid={`cnt-faq-${i}`}>
                <h3 className="font-serif text-xl text-olive-dark">{f.q}</h3>
                <p className={`mt-3 text-sm leading-relaxed ${f.a.includes("[À RENSEIGNER]") ? "text-terracotta" : "text-sage"}`}>{f.a}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* SECTION 12 — CTA FINAL */}
      <section className="bg-olive-dark text-beige-100" data-testid="cnt-cta-final">
        <div className="max-w-4xl mx-auto px-6 py-24 lg:py-28 text-center">
          <Reveal>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light leading-tight">Prêt·e à approfondir votre pratique ?</h2>
            <p className="mt-6 text-beige-300/90 leading-relaxed max-w-xl mx-auto">
              Venez apprendre le Chi Nei Tsang dans un cadre exigeant, humain et profondément tourné vers la qualité du toucher.
            </p>
            <p className="mt-4 text-sm text-gold" data-testid="cnt-cta-recap">Du 26 au 30 octobre 2026 · Bayonne · 1 100 € · 4 places ouvertes</p>
            <div className="mt-9 flex flex-wrap justify-center gap-4">
              <Link to={CONTACT} data-testid="cnt-cta-inscription" className="inline-flex items-center gap-2 rounded-full bg-beige-100 px-8 py-4 text-sm font-medium text-olive-dark transition-all duration-300 hover:-translate-y-0.5 hover:bg-beige-50">
                Je souhaite m'inscrire <ArrowUpRight className="w-4 h-4" strokeWidth={1.5} />
              </Link>
              <a href={WA} target="_blank" rel="noopener noreferrer" data-testid="cnt-cta-question" className="inline-flex items-center rounded-full border border-beige-100/40 px-8 py-4 text-sm text-beige-100 transition-all duration-300 hover:bg-beige-100/10">
                J'ai une question
              </a>
            </div>
          </Reveal>
        </div>
      </section>

      <footer className="border-t border-olive-border py-6 text-center text-xs text-sage">
        <Link to="/" className="hover:text-olive transition-colors">juliezittel.com</Link> — Thérapeute & formatrice, Bayonne · Bellignat
      </footer>
    </div>
  );
}
